import { createContext, useContext, useEffect } from 'react';
import { CapacityManagementRootResponse } from 'src/apis/capacity-management/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleRequestError } from 'src/utils/axios-config';
import { reportError } from 'src/utils/report-error';

// this hook will be used while the parellel prod deployment of capacity management.
// we safely try to access the root resource to figure out if the user should see
// capacity management features or not.
export function useCapacityManagementRequest() {
  const capacityManagement = useAxios(
    (axios, signal) =>
      axios.request<CapacityManagementRootResponse>({
        signal,
        url: PRISMA_CONFIG.capacityManagement,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      onError(error) {
        const [_, report] = handleRequestError(error, () => {});
        if (report) reportError(error);
        return error;
      },
    }
  );

  useEffect(() => {
    capacityManagement.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return capacityManagement;
}

export type CapacityManagementRootRequest = ReturnType<
  typeof useCapacityManagementRequest
>;

const CapacityManagementContext = createContext<
  CapacityManagementRootResponse | undefined
>(undefined);

export const CapacityManagementProvider = CapacityManagementContext.Provider;

export function useCapacityManagement() {
  return useContext(CapacityManagementContext);
}
